// eslint-disable-next-line import/prefer-default-export
export const copy = val => new Promise(resolve => {
  if (typeof val !== 'string') {
    throw new Error('Copy to clipboard failed. Can only copy a text.')
  }

  navigator.clipboard.writeText(val)
  resolve('success')
})
